import LoadCountriesUseCase from "../../use_cases/addresses/countries/list_countries_use_case.js";
import { RawIdentityDocumentModel } from "../users/identity_document_model.js";
import IdentityDocumentTypeEnum from "../../enums/identity_document_type.js"

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawProfileIdentityDocumentModel extends RawIdentityDocumentModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "type",
        displayName: this.fieldDisplayName("type"),
        type: "enum",
        enum: IdentityDocumentTypeEnum,
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
      },
      {
        name: "number",
        displayName: this.fieldDisplayName("number"),
        type: "text",
        weight: 6,
        displayNamePosition: InputLabelDisplayModeAbove,
        disableAutoComplete: true
      },
      {
        name: "issueDate",
        displayName: this.fieldDisplayName("issueDate"),
        type: "dateTime",
        format: "DD.MM.YYYY",
        weight: 6,
        displayNamePosition: InputLabelDisplayModeAbove,
      },
      {
        name: "expiryDate",
        displayName: this.fieldDisplayName("expiryDate"),
        type: "dateTime",
        format: "DD.MM.YYYY",
        weight: 6,
        displayNamePosition: InputLabelDisplayModeAbove,
        disableAutoComplete: true
      },
      {
        name: "issuingCountry",
        displayName: this.fieldDisplayName("issuingCountry"),
        type: "model",
        useCase: LoadCountriesUseCase,
        foreignKey: "issuingCountryId",
        weight: 6,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "issuingAuthority",
        displayName: this.fieldDisplayName("issuingAuthority"),
        type: "text",
        weight: 6,
        displayNamePosition: InputLabelDisplayModeAbove
      },
    ]
  }

}
const ProfileIdentityDocumentModel = new RawProfileIdentityDocumentModel();

export { RawProfileIdentityDocumentModel, ProfileIdentityDocumentModel }